import { PaginationType } from 'types';

export const __PageQueryKey = (postsQueryKey: readonly unknown[]) => [...postsQueryKey, 'page'] as const;

export function __LoadedPage<T>(cached: PaginationType<T> | undefined, pageSize: number): number {
    if (!cached?.data.length) return 1;
    return Math.min(cached.num_of_pages, Math.max(1, Math.ceil(cached.data.length / pageSize)));
}

export function __MergePaginationPage<T>(
    page: number,
    data: PaginationType<T>,
    prev?: PaginationType<T>,
): PaginationType<T> {
    if (page === 1) return data;
    return { ...data, data: [...(prev?.data ?? []), ...data.data] };
}
